import { Directions } from '../interfaces/Directions';

export const DIRECTIONS: { [key: string]: Directions } = {
	LTR: 'ltr',
	RTL: 'rtl',
};
